import React from "react";
import { Link } from "react-router-dom";

const AccessDenied = () => (
  <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "70vh" }}>
    <i className="la la-lock text-danger" style={{ fontSize: "4rem" }} />
    <h2 className="mt-3 mb-2">Access Denied</h2>
    <p className="text-muted text-center" style={{ maxWidth: 420 }}>
      You don't have permission to view this module. Contact your administrator
      to request access.
    </p>
    <Link to="/dashboard" className="btn btn-primary mt-3">
      Back to Dashboard
    </Link>
  </div>
);

export default AccessDenied;
